
import './App.css';
import AppContextProvider from './contextApi/ContextApi';
import AppRouter from './components/Routes/AppRouter';
import { Bounce, ToastContainer } from 'react-toastify';
import "./dataSets/chartSetup.js";

function App() {

  return (
    <div className="App">
      <AppContextProvider>

        {/* toast messages component */}
        <ToastContainer style={{zIndex:1000010}} position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick={true} rtl pauseOnFocusLoss={false} draggable pauseOnHover theme="dark" transition={Bounce}/>

        {/* All routes at AppRouter */}
        <AppRouter/>
        
      </AppContextProvider>
    </div>
  );
}

export default App;
